import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Dispositions',
		url: '/dispositions',
		icon: 'upload',
	},
	{
		name: 'Multiple Sales',
		url: '/dispositions/multiple_sales',
		icon: 'clone',
	},
];

export default class Multiple_Sales extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Collections.DispositionsMultipleSales
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

			</div>
		);
	}
}
